import { Footer } from '@/components/Footer';
import { Navbar } from '@/components/Navbar';

export default function TermsPage() {
  return (
    <div className="flex min-h-screen flex-col bg-neutral-50 text-neutral-800">
      <Navbar />

      <main className="mx-auto w-full max-w-4xl flex-1 px-4 pb-12 pt-28 sm:px-6 lg:px-8">
        <div className="rounded-lg bg-white p-8 shadow-sm">
          <h1 className="mb-4 font-heading text-3xl font-bold text-neutral-900">
            Termeni și Condiții – SolomonQ
          </h1>

          <p className="mb-6 text-sm text-neutral-600">
            <strong>Ultima actualizare:</strong> 15 ianuarie 2026
            <br />
            <strong>Operator:</strong> Platforma „SolomonQ" este operată
            provizoriu de fondatori („Operatorii"). Contact:{' '}
            <a
              href="mailto:solomonq.team@gmail.com"
              className="text-primary hover:underline">
              solomonq.team@gmail.com
            </a>
            .
            <br />
            Prin utilizarea <strong>solomonq.com</strong> („Platforma"), accepți
            acești Termeni.
          </p>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              1) Serviciul
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              SolomonQ agregă știri economice din surse terțe, afișează titluri,
              rezumate automate, linkuri către sursă și grafice orientative.
              Sunt disponibile filtre și funcționalități AI .
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              2) Utilizare permisă
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Primești o licență personală, neexclusivă, revocabilă, pentru a
              accesa Platforma în scop informativ. Este interzisă folosirea în
              scopuri ilegale sau care încalcă drepturile terților.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              3) Proprietate intelectuală
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Interfața, selecția și algoritmii Platformei aparțin
              Operatorilor/licențiatorilor.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              4) Date, grafice și limitări
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Datele de preț pot fi întârziate sau incomplete. Graficele au
              caracter exclusiv orientativ și nu constituie cotații oficiale ori
              ferme. Indicatorii privind frecvența știrilor sunt generați
              automat și pot include erori de clasificare, deduplicare sau
              întârziere. Utilizarea Platformei și a datelor aferente nu implică
              nicio garanție privind acuratețea, exhaustivitatea ori
              actualitatea acestora; răspunderea pentru decizii sau acțiuni
              întemeiate pe aceste informații aparține exclusiv utilizatorilor,
              în limitele legii.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              5) Funcționalități AI
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Rezumatul, detecția simbolurilor, evaluarea de favorabilitate și
              „AI curator" sunt generate automat și pot fi eronate sau
              incomplete. Prompturile/criteriile furnizate de tine trebuie să
              fie legale și adecvate. Verifică întotdeauna sursa originară.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              6) Fără consultanță financiară
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Conținutul are exclusiv scop informativ/educațional. Nu reprezintă
              recomandare de investiții, ofertă/solicitare de tranzacționare și
              nu înlocuiește consultanța unui specialist autorizat.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              7) Conturi și confidențialitate
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Dacă îți creezi cont, ești responsabil pentru păstrarea
              confidențialității credențialelor și pentru activitatea
              desfășurată în cont.
              <br />
              <br />
              Prelucrarea datelor cu caracter personal se face conform cadrului
              legal aplicabil (GDPR și legislația română). Colectăm minimul
              necesar de date pentru: furnizarea și securizarea Platformei,
              comunicări administrative, suport, analitice de bază și
              îmbunătățirea serviciului.
              <br />
              <br />
              Drepturile tale pot fi exercitate la{' '}
              <a
                href="mailto:solomonq.team@gmail.com"
                className="text-primary hover:underline">
                solomonq.team@gmail.com
              </a>
              .
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              8) Abonamente, plăți și facturare
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Platforma poate include planuri gratuite și planuri contra cost
              („Abonamente”), cu limite și funcționalități diferite, descrise în
              Platformă (de ex. pe pagina de „Upgrade”/prețuri) și/sau în contul
              tău.
              <br />
              <br />
              <strong>Reînnoire automată:</strong> Abonamentele plătite se
              reînnoiesc automat la fiecare perioadă de facturare (de regulă,
              lunar), până la anulare. Taxele se pot percepe în avans pentru
              perioada următoare, conform detaliilor afișate înainte de
              confirmarea achiziției.
              <br />
              <br />
              <strong>Procesarea plăților:</strong> Plățile sunt procesate de un
              procesator de plăți terț. Operatorii nu stochează integral datele
              cardului tău; anumite informații (de exemplu, identificatori de
              tranzacție/abonament) pot fi păstrate pentru facturare, suport și
              conformitate.
              <br />
              <br />
              <strong>Prețuri și taxe:</strong> Prețurile sunt cele afișate în
              Platformă la momentul comenzii. Putem modifica planurile,
              prețurile sau caracteristicile acestora; modificările vor fi
              comunicate prin Platformă și, în mod normal, se vor aplica de la
              următoarea perioadă de facturare, dacă nu se indică altfel.
              <br />
              <br />
              <strong>Anulare:</strong> Poți anula Abonamentul oricând din
              setările contului sau contactând Operatorii. Anularea produce
              efect imediat: contul tău va fi retrogradat la planul Gratuit, iar
              limitele/funcționalitățile corespunzătoare se aplică imediat.
              <br />
              <br />
              <strong>Rambursări:</strong> Cu excepția cazurilor în care legea
              aplicabilă prevede altfel, plățile efectuate nu sunt rambursabile,
              inclusiv pentru perioade parțiale neutilizate.
              <br />
              <br />
              <strong>Perioade de probă:</strong> Putem oferi, ocazional,
              perioade de probă. Dacă este cazul, condițiile (durată,
              eligibilitate, și dacă este necesară o metodă de plată) vor fi
              afișate în Platformă. Dacă proba se încheie și nu anulezi înainte,
              Abonamentul poate începe și se poate factura conform planului
              selectat.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              9) Răspundere
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              În limitele maxime permise de legislația aplicabilă, Operatorii,
              afiliații, colaboratorii și furnizorii acestora sunt exonerați de
              răspundere pentru orice fel de prejudicii, directe sau indirecte,
              imediate ori consecutive (inclusiv, fără limitare, pierderi de
              profit, venituri, oportunități, date sau goodwill), apărute din
              ori în legătură cu accesarea, utilizarea sau imposibilitatea de
              utilizare a Platformei și/sau a Conținutului. Aceasta include,
              fără caracter limitativ, prejudicii decurgând din inexactități,
              omisiuni, întârzieri sau indisponibilități ale datelor, erori ale
              sistemelor sau ale componentelor de inteligență artificială,
              disfuncționalități tehnice, întreruperi ale serviciilor, incidente
              de securitate, acces sau utilizare neautorizată. Limitarea se
              aplică indiferent de temeiul juridic invocat. Nicio prevedere din
              acești Termeni nu exclude și nu limitează răspunderea care nu
              poate fi exclusă sau limitată potrivit legii.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              10) Modificări, suspendare și cesiune
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Putem modifica Termenii și/sau Platforma oricând, prin publicare
              pe site. Putem suspenda/înceta accesul în caz de încălcare sau
              pentru motive operaționale/de securitate. Putem cesiona
              drepturile/obligațiile cu notificare prin site.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="mb-3 text-xl font-semibold text-neutral-800">
              11) Legea aplicabilă, litigii și contact
            </h2>
            <p className="text-sm leading-relaxed text-neutral-700">
              Se aplică legea română; litigiile se soluționează de instanțele
              competente din România.
              <br />
              <br />
              Întrebări/solicitări sau notificări privind drepturile
              editoriale/autor:{' '}
              <a
                href="mailto:solomonq.team@gmail.com"
                className="text-primary hover:underline">
                solomonq.team@gmail.com
              </a>{' '}
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
